

<div class="d-flex flex-column padding" style="border-radius: 30px">
  <img
    src="assets/svg/x.svg"
    alt=""
    class="close-button"
    (click)="cancel()"
    width="14px"
    height="14px"
  />
  <h3 class="plus-mt">Términos y condiciones</h3>

  <div class="line"></div>
  <div
    [innerHTML]="content"
    style="text-align: justify; max-height: 30rem; overflow-y: scroll"
  ></div>
  <div class="d-flex space-center mt-4">
    <button class="btn fill-available btn-border-black" (click)="cancel()">
      Rechazo
    </button>
    <button
      class="btn fill-available btn-black"
      style="margin-left: 2rem"
      (click)="submit()"
    >
      Acepto
    </button>
  </div>
</div>
